import { actions }  from "../../actions/common/industries";

export default function industries ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case actions.SET_INDUSTRIES:
            return setIndustries( newState, action.industries );
        default: return newState;
    }
}

function setIndustries ( newState, industries ) {
    newState.industries = industries;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/common/industries.js